export default __webpack_public_path__ + "static/media/nl.db73c245.svg";